<app-header-patient></app-header-patient>
<router-outlet></router-outlet>